export default __webpack_public_path__ + "static/media/no11.9c8a7b1c.png";